<div class="form-sub-title">Foto</div>
<div class="rounded-circle employee-initials in-the-middle">
  <span *ngIf="user.profilePicture == null && offlineProfilePicture == null">
    {{ user.firstName | initials : user.lastName }}
  </span>
  <div *ngIf="user.profilePicture != null && offlineProfilePicture == null">
    <img
      class="rounded-circle"
      *ngIf="isImage(user.profilePicture)"
      src="/api/assets/{{ user.profilePicture.uuid }}"
      width="120px"
      height="120px"
    />
  </div>
  <div *ngIf="offlineProfilePicture != null">
    <img
      class="rounded-circle"
      *ngIf="isImage(offlineProfilePicture)"
      [src]="offlineProfilePicture.localSafeUrl"
      width="120px"
      height="120px"
    />
  </div>
</div>
<button
  class="button btn no-margin"
  type="button"
  (click)="profilePictureInput.click()"
>
  <span>Bestand uploaden</span>
  <input
    #profilePictureInput
    class="hidden"
    type="file"
    ng2FileSelect
    [uploader]="uploader"
    (onFileSelected)="setOfflineProfilePicture($event)"
    accept=".png,.jpg,.jpeg,.pdf,image/png,image/jpg,image/jpeg,application/pdf"
  />
</button>
